import React from 'react';
import './ContactCard.scss';

const ContactCard = ({ contact }) => {

  return (
    <div className="contact-card">
      <div className="contact-card__header">
        <div className="contact-card__title-group">
          <div className="contact-card__title">
            {contact?.label || (
              (contact?.last_name ? `${contact?.last_name}` : '') +
              (contact?.first_name ? ` ${contact?.first_name}` : '') +
              (contact?.patronymic ? ` ${contact?.patronymic}` : '')
            ) || 'Имя контакта'}
          </div>
          {contact.position && (
            <div className="contact-card__position">
              {contact?.position}
            </div>
          )}
        </div>
      </div>

      <div className="contact-card__grid">
        {/* Телефон */}
        <div className="contact-card__item">
          <div className="contact-card__item-label">Телефон</div>
          <div className="contact-card__item-value">
            {contact?.phone || '-'}
          </div>
        </div>

        {/* Email */}
        <div className="contact-card__item">
          <div className="contact-card__item-label">Email</div>
          <div className="contact-card__item-value contact-card__item-value--break">
            {contact?.email || '-'}
          </div>
        </div>

        {/* Компания */}
        {contact?.company && <div className="contact-card__item">
          <div className="contact-card__item-label">Компания</div>
          <div className="contact-card__item-value">
            {contact?.company || '-'}
          </div>
        </div>}

        {/* Должность */}
        <div className="contact-card__item">
          <div className="contact-card__item-label">Должность</div>
          <div className="contact-card__item-value">
            {contact?.position || '-'}
          </div>
        </div>

        {/* Способ связи */}
        <div className="contact-card__item">
          <div className="contact-card__item-label">Способ связи</div>
          <div className="contact-card__item-value">
            {contact?.communication || '-'}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactCard;